import Collection from '../../service/_collection'
import tourData from '../const/tour_result.json'
import areaCode from '../const/area_result.json'
import airportCode from '../const/airport_result.json'
import countryCode from '../const/country_result.json'
import cityCode from '../const/city_result.json'

/**
 * SearchConditions // 検索条件のロジック
 *
 * @returns {undefined}
 */

class SearchConditions {
  /**
   * departureCodeList // 出発地コードを取得
   */
  departureCodeList() {
    const airportArray = new Collection(airportCode)
    const array = []

    airportArray.sort(false, 'display').map(item => {
      if (tourData.some(tour => tour.airport_code === item.code) || item.city_flag) {
        array.push({ key: item.code, value: item.name })
      }
    })
    array.unshift({ key: 'none', value: '出発地を選択' })
    return array
  }

  /**
   * areaCodeList // エリアコードを取得
   */
  areaCodeList() {
    const dataArray = new Collection(areaCode)

    const array = dataArray
      .map(item => {
        return { key: item.code, value: item.name }
      })
      .unshift({ key: 'none', value: '方面を選択' })
      .get()
    return array
  }

  /**
   * departureCodeToSelectData //
   */
  departureCodeToSelectData(code, filterList) {
    const dataArray = new Collection(areaCode)
    const array = []

    dataArray.map(item => {
      if (
        tourData.some(
          tour =>
            (tour.area_code === item.code && tour.airport_code === code) ||
            (tour.area_code === item.code && tour.departure_city_code === code),
        )
      ) {
        array.push({ key: item.code, value: item.name })
      } else {
        array.push({ key: item.code, value: item.name, disable: true })
      }
    })
    array.unshift({ key: 'none', value: '方面を選択' })

    const array3 = array.map(item => {
      let match = false
      if (filterList && item) {
        match = filterList.some(uniqueItem => uniqueItem.key === item.key)
      }
      if (match === true) {
        return { key: item.key, value: item.value }
      } else {
        return { key: item.key, value: item.value, disable: true }
      }
    })

    return array3
  }

  /**
   * areaCodeToSelectData // エリアコードの定義から選択肢のデータを作成する
   *
   * @param {string} code // エリアコード
   */
  areaCodeToSelectData(code, filterList) {
    console.log('※', code)
    if (code === 'none') return [{ key: 'none', value: '国・地域を選択' }]
    const dataArray = new Collection(countryCode)
    const dataArray2 = new Collection(countryCode)

    const array2 = dataArray2
      .filter(item => item.area_code === code)
      .filter(item => item.display === null)
      .sort(false, 'name_ja')
      .map(item => {
        return { key: item.code, value: item.name }
      })
      .get()

    const array = dataArray
      .filter(item => item.area_code === code)
      .filter(item => item.display !== null)
      .sort(false, 'display')
      .map(item => {
        return { key: item.code, value: item.name }
      })
      .unshift({ key: 'none', value: '国・地域を選択' })
      .concat(array2)
      .get()

    const array3 = array.map(item => {
      let match = false
      if (filterList && item) {
        match = filterList.some(uniqueItem => uniqueItem.key === item.key)
      }
      if (match === true) {
        return { key: item.key, value: item.value }
      } else {
        return { key: item.key, value: item.value, disable: true }
      }
    })

    return array3
  }

  /**
   * countryCodeToSelectData // 国コードの定義から選択肢のデータを作成する
   *
   * @param {string} code // 国コード
   */
  countryCodeToSelectData(code, filterList) {
    if (code === 'none') return [{ key: 'none', value: '都市を選択' }]
    const dataArray = new Collection(cityCode)

    const array = dataArray
      .filter(item => item.country_code === code)
      .sort(false, 'display')
      .map(item => {
        return { key: item.code, value: item.name_ja }
      })
      .unshift({ key: 'none', value: '都市を選択' })
      .get()

    const array3 = array.map(item => {
      let match = false
      if (filterList && item) {
        match = filterList.some(uniqueItem => uniqueItem.key === item.key)
      }
      if (match === true) {
        return { key: item.key, value: item.value }
      } else {
        return { key: item.key, value: item.value, disable: true }
      }
    })

    return array3
  }

  /**
   * stayDaysList // 旅行日数を取得
   */
  stayDaysList(dayList) {
    // const airportArray = new Collection(airportCode)
    // const array = []
    console.log('stayDaysList', dayList)
    const array = [
      { key: '1', value: '1日' },
      { key: '2', value: '2日' },
      { key: '3', value: '3日' },
      { key: '4', value: '4日' },
      { key: '5', value: '5日' },
      { key: '6', value: '6日' },
      { key: '7', value: '7日' },
      { key: '8', value: '8日' },
      { key: '9', value: '9日' },
      { key: '10', value: '10日' },
    ]
console.log('dayList', dayList)
    const array2 = array.map(item => {
      if (dayList && dayList.length > 0 && dayList.some(day => day === item.key)) {
        return item
      } else {
        return {
          key: item.key,
          value: item.value,
          disable: true,
        }
      }
    })
    array2.unshift({ key: 'none', value: '旅行日数を選択' })
    console.log('stayDaysList:array', array2)

    return array2
  }
}

export default new SearchConditions()
